// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-width{
    width: 100%;
}
.mat-button.buttons-custom{
    color: white ;
      background: #7e55b3;
      margin: 10px 5px 0 5px;
  }
  
  .mat-button.cancel{
    background:#e6e6e6;
    margin: 10px 5px 0 5px;
  }

  .cdk-overlay-pane {
    max-width: 40vw !important;
    
  }
  


  

  ::ng-deep  .mat-mdc-dialog-container{
    height: initial;
    overflow: initial;
  }
  
  /*//End angular-editor customization*/

  ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {
    top: 0.6em !important;
    bottom: 0 !important;
  }
  
  
  
  ::ng-deep .mdc-text-field--filled.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-text-field__input{
    caret-color: #ff1100dc;
  }
  ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled){
    background-color: transparent !important;
  
  }
  
  
  
  
  ::ng-deep
    .mat-form-field-flex:hover
    .mat-form-field-outline.mat-form-field-outline-thick {
    color: #05b9ff !important;
  }
  
  .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {
    color: #05b9ff !important;
  }
  
  
  ::ng-deep .mat-form-field-wrapper{
    margin-bottom: -1.25em;
  }
  /*//End mat-form-field customization*/`, "",{"version":3,"sources":["webpack://./src/app/views/component-page/add-edit-component/add-edit-component.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,aAAa;MACX,mBAAmB;MACnB,sBAAsB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;;EAE5B;;;;;;EAMA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,qCAAqC;;EAErC;IACE,qBAAqB;IACrB,oBAAoB;EACtB;;;;EAIA;IACE,sBAAsB;EACxB;EACA;IACE,wCAAwC;;EAE1C;;;;;EAKA;;;IAGE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,sBAAsB;EACxB;EACA,qCAAqC","sourcesContent":[".full-width{\r\n    width: 100%;\r\n}\r\n.mat-button.buttons-custom{\r\n    color: white ;\r\n      background: #7e55b3;\r\n      margin: 10px 5px 0 5px;\r\n  }\r\n  \r\n  .mat-button.cancel{\r\n    background:#e6e6e6;\r\n    margin: 10px 5px 0 5px;\r\n  }\r\n\r\n  .cdk-overlay-pane {\r\n    max-width: 40vw !important;\r\n    \r\n  }\r\n  \r\n\r\n\r\n  \r\n\r\n  ::ng-deep  .mat-mdc-dialog-container{\r\n    height: initial;\r\n    overflow: initial;\r\n  }\r\n  \r\n  /*//End angular-editor customization*/\r\n\r\n  ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {\r\n    top: 0.6em !important;\r\n    bottom: 0 !important;\r\n  }\r\n  \r\n  \r\n  \r\n  ::ng-deep .mdc-text-field--filled.mdc-text-field--invalid:not(.mdc-text-field--disabled) .mdc-text-field__input{\r\n    caret-color: #ff1100dc;\r\n  }\r\n  ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled){\r\n    background-color: transparent !important;\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  \r\n  ::ng-deep\r\n    .mat-form-field-flex:hover\r\n    .mat-form-field-outline.mat-form-field-outline-thick {\r\n    color: #05b9ff !important;\r\n  }\r\n  \r\n  .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {\r\n    color: #05b9ff !important;\r\n  }\r\n  \r\n  \r\n  ::ng-deep .mat-form-field-wrapper{\r\n    margin-bottom: -1.25em;\r\n  }\r\n  /*//End mat-form-field customization*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
